class StreamFile {
    constructor() {
        this.mp3Uri = null;
        this.oggUri = null;
        this.mp4Uri = null;
    }
}

export { StreamFile };
